export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14285.cabd347c.jpg";